document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-drawer-toggle]');
  if (toggle) {
    const drawer = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!drawer) return;
    const open = drawer.toggleAttribute('data-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  const drawer = document.querySelector('[data-open]');
  if (!drawer) return;
  drawer.removeAttribute('data-open');
  const toggle = document.querySelector(`[aria-controls="${drawer.id}"]`);
  if (toggle) {
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();
  }
});
